import React from 'react';
export function PainAgitation() {
  return <section className="bg-forest py-12 md:py-16 px-5" data-id="element-513">
      <div className="max-w-4xl mx-auto" data-id="element-514">
        {/* Section Title */}
        <h2 className="font-serif text-white text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-515">
          Does This Sound Familiar?
        </h2>

        {/* Pain Point Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-516">
          {/* Card 1 */}
          <div className="bg-white/10 backdrop-blur border-l-4 border-burnt shadow-md rounded-lg p-6" data-id="element-517">
            <span className="text-3xl block mb-3" role="img" aria-hidden="true" data-id="element-518">
              🥶
            </span>
            <p className="font-sans text-white/80 leading-relaxed" data-id="element-519">
              <span className="font-bold text-white" data-id="element-520">
                You wake up after a cold night
              </span>{' '}
              and find your favorite flowers dead — again.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white/10 backdrop-blur border-l-4 border-burnt shadow-md rounded-lg p-6" data-id="element-521">
            <span className="text-3xl block mb-3" role="img" aria-hidden="true" data-id="element-522">
              ☀️
            </span>
            <p className="font-sans text-white/80 leading-relaxed" data-id="element-523">
              <span className="font-bold text-white" data-id="element-524">A July heat wave</span>{' '}
              turns your $200 hydrangeas into crispy brown sticks.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white/10 backdrop-blur border-l-4 border-burnt shadow-md rounded-lg p-6" data-id="element-525">
            <span className="text-3xl block mb-3" role="img" aria-hidden="true" data-id="element-526">
              🌪️
            </span>
            <p className="font-sans text-white/80 leading-relaxed" data-id="element-527">
              <span className="font-bold text-white" data-id="element-528">
                A storm snaps branches
              </span>{' '}
              and floods your beds — and you had no plan.
            </p>
          </div>

          {/* Card 4 */}
          <div className="bg-white/10 backdrop-blur border-l-4 border-burnt shadow-md rounded-lg p-6" data-id="element-529">
            <span className="text-3xl block mb-3" role="img" aria-hidden="true" data-id="element-530">
              💸
            </span>
            <p className="font-sans text-white/80 leading-relaxed" data-id="element-531">
              <span className="font-bold text-white" data-id="element-532">
                You spend hundreds every spring
              </span>{' '}
              replacing plants that didn't survive winter.
            </p>
          </div>
        </div>

        {/* Bottom Statement */}
        <p className="text-center text-lg md:text-xl text-white/90 font-serif italic max-w-2xl mx-auto leading-relaxed" data-id="element-533">
          "You're not a bad gardener. You just never had a system built for{' '}
          <span className="font-bold not-italic" data-id="element-534">YOUR</span> climate."
        </p>
      </div>
    </section>;
}